module.exports = __webpack_public_path__ + "img/15.7bad566a.svg";